<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */

import { computed } from "vue";
import { useMainStore } from "@/store/main/index";
import type { SecondaryDataInterface } from "@/types/ContentType";

import { getWidgetSS } from "@/composables/core/func";

import Form from "./parts/Form.vue";
import Info from "./parts/Info.vue";
import Grid from "@/components/regularComponents/layoutComponents/Grid.vue";

const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

await getWidgetSS(["areyouinterestedimages"]);

const mainStore = useMainStore();
const images = computed(() => mainStore.widgets?.areyouinterestedimages);

defineProps<{
  contentData?: SecondaryDataInterface;
}>();
</script>

<template>
  <section class="are-you-interested pos-rel">
    <Grid :gridType="3" />

    <div class="d-flex are-you-interested-in al-start pos-rel z-1">
      <div v-if="images?.left" class="are-you-interested__banner left ov-hidden">
        <Picture :devices="images?.left?.[0]?.devices" alt="left image" parallax />
      </div>

      <div class="are-you-interested__items d-flex">
        <Form :title="contentData?.conf?.header?.title" />
        
        <Info />
      </div>

      <div v-if="images?.right" class="are-you-interested__banner right ov-hidden">
        <Picture :devices="images?.right?.[0]?.devices" alt="right image" parallax />
      </div>
    </div>
  </section>
</template>

<style lang="scss" src="./style/areYouInterested.scss" />
